
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AgendamentosConcluidos.css";

const AgendamentosConcluidos = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [erro, setErro] = useState(null);
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");
  const [editandoPreco, setEditandoPreco] = useState(null);
  const [novoPreco, setNovoPreco] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFuncionarios = async () => {
      try {
        await api.get("/verificar-autenticacao", { withCredentials: true });

        const response = await api.get("/funcionarios", {
          withCredentials: true,
        });

        setFuncionarios(response.data);
      } catch (err) {
        setErro("Erro ao carregar funcionários. Redirecionando para o login...");
        navigate("/login");
      }
    };

    fetchFuncionarios();

    const disableInspect = (event) => {
      if (
        event.key === "F12" ||
        (event.ctrlKey && event.shiftKey && event.key === "I") ||
        (event.ctrlKey && event.key === "U")
      ) {
        event.preventDefault();
      }
    };

    const disableRightClick = (event) => event.preventDefault();

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableInspect);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableInspect);
    };
  }, [navigate]);

  useEffect(() => {
    const fetchAgendamentosConcluidos = async () => {
      try {
        await api.get("/verificar-autenticacao", { withCredentials: true });

        const url = funcionarioSelecionado
          ? `/agendamentos/concluidos?funcionario_id=${funcionarioSelecionado}`
          : "/agendamentos/concluidos";

        const response = await api.get(url, { withCredentials: true });
        setAgendamentos(response.data);
      } catch (err) {
        setErro("Erro ao carregar agendamentos concluídos. Redirecionando para o login...");
        navigate("/login");
      }
    };

    fetchAgendamentosConcluidos();
  }, [funcionarioSelecionado, navigate]);

  const formatarData = (data) => {
    const utcDate = new Date(data);
    const localDate = new Date(
      utcDate.getTime() + utcDate.getTimezoneOffset() * 60000
    );
    return localDate.toLocaleDateString("pt-BR");
  };

  const formatarHora = (hora) => {
    if (!hora) return "Não informado";
    const [hours, minutes] = hora.split(":");
    return `${hours}:${minutes}`;
  };

  const formatarTelefone = (telefone) => {
    if (!telefone) return "Não informado";

    const padraoTelefone = /^\(\d{2}\)\s?\d{4,5}-?\d{4}$/;

    if (padraoTelefone.test(telefone)) return telefone;

    return telefone.replace(/(\d{2})(\d{4,5})(\d{4})/, "($1) $2-$3");
  };

  const formatarPreco = (preco) => {
    if (!preco && preco !== 0) return "Não informado";
    return `R$ ${parseFloat(preco).toFixed(2)}`;
  };

  const obterPrecoExibido = (agendamento) => {
    return agendamento.preco_final !== null &&
      agendamento.preco_final !== undefined
      ? agendamento.preco_final
      : agendamento.servico_preco;
  };

  const iniciarEdicaoPreco = (agendamento) => {
    setEditandoPreco(agendamento.id);
    setNovoPreco(obterPrecoExibido(agendamento));
  };

  const cancelarEdicao = () => {
    setEditandoPreco(null);
    setNovoPreco("");
  };

  const salvarPreco = async (agendamentoId) => {
    try {
      const response = await api.put(
        `/agendamentos/concluidos/${agendamentoId}/preco`,
        { preco_final: parseFloat(novoPreco) },
        { withCredentials: true }
      );

      if (response.status === 200) {
        setAgendamentos((prevAgendamentos) =>
          prevAgendamentos.map((ag) =>
            ag.id === agendamentoId
              ? { ...ag, preco_final: parseFloat(novoPreco) }
              : ag
          )
        );

        setEditandoPreco(null);
        setNovoPreco("");
      }
    } catch (err) {
      setErro("Erro ao atualizar preço. Tente novamente.");
      console.error("Erro ao atualizar preço:", err);
    }
  };


  const gerarRelatorio = async () => {
    try {
      setErro(null);

      // Confirma a autenticação antes de gerar o relatório
      await api.get("/verificar-autenticacao", {
        withCredentials: true,
      });

      const url = funcionarioSelecionado
        ? `/agendamentos/concluidos/relatorio?funcionario_id=${funcionarioSelecionado}`
        : "/agendamentos/concluidos/relatorio";

      const response = await api.get(url, {
        withCredentials: true,
        responseType: "blob",
      });

      // Quando a resposta é um Blob, até mensagens de erro do backend
      // podem chegar como Blob em vez de JSON.
      if (response.data instanceof Blob && response.data.size === 0) {
        setErro("O relatório está vazio. Não há dados disponíveis para exportação.");
        return;
      }

      // Valida se o conteúdo retornado é realmente um PDF.
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (blob.size === 0) {
        setErro("Não foi possível gerar o relatório porque não há dados disponíveis.");
        return;
      }

      const urlBlob = window.URL.createObjectURL(blob);

      const dataAtual = new Date();
      const dia = String(dataAtual.getDate()).padStart(2, "0");
      const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
      const ano = dataAtual.getFullYear();
      const dataFormatada = `${dia}-${mes}-${ano}`;

      const nomeArquivo = `relatorio_semanal_${dataFormatada}.pdf`;

      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = nomeArquivo;
      link.click();

      window.URL.revokeObjectURL(urlBlob);
    } catch (err) {
      // Só redireciona quando a autenticação realmente falhar.
      if (err.response?.status === 401 || err.response?.status === 403) {
        setErro("Sua sessão expirou. Faça login novamente para continuar.");
        navigate("/login");
        return;
      }

      // Se a API retornou uma mensagem de erro como Blob, tenta interpretá-la.
      const tratarErro = async () => {
        let mensagemBackend = "";

        if (err.response?.data instanceof Blob) {
          try {
            const texto = await err.response.data.text();
            const dados = JSON.parse(texto);
            mensagemBackend = dados.erro || dados.mensagem || dados.message || "";
          } catch {
            // A resposta não era JSON; usa a mensagem padrão abaixo.
          }
        } else if (typeof err.response?.data === "object") {
          mensagemBackend =
            err.response.data.erro ||
            err.response.data.mensagem ||
            err.response.data.message ||
            "";
        }

        if (err.response?.status === 404 || err.response?.status === 204) {
          setErro("Não há agendamentos disponíveis para gerar o relatório.");
        } else {
          setErro(
            mensagemBackend ||
            "Não foi possível gerar o relatório. Verifique se existem agendamentos concluídos e tente novamente."
          );
        }
      };

      await tratarErro();
      console.error("Erro ao gerar relatório PDF:", err);
    }
  };


  return (
    <main className="concluidos-page">
      <section className="concluidos-container">
        <header className="concluidos-header">
          <div className="concluidos-heading">
            <span className="concluidos-eyebrow">
              HISTÓRICO DE ATENDIMENTOS
            </span>

            <h2>Agendamentos Concluídos</h2>

            <p>
              Consulte os atendimentos finalizados e gerencie os valores
              cobrados.
            </p>
          </div>

          <div className="concluidos-counter">
            <span className="concluidos-counter-label">
              Registros carregados
            </span>
            <strong>{agendamentos.length}</strong>
            <span className="concluidos-counter-caption">
              {agendamentos.length === 1
                ? "agendamento"
                : "agendamentos"}
            </span>
          </div>
        </header>

        {erro && (
          <div className="concluidos-alert" role="alert">
            <span className="concluidos-alert-icon">!</span>
            <p>{erro}</p>
          </div>
        )}

        <section className="concluidos-filters">
          <div className="concluidos-filter-heading">
            <div className="concluidos-filter-icon">⌕</div>
            <div>
              <h3>Filtrar atendimentos</h3>
              <p>Visualize os registros de um profissional específico.</p>
            </div>
          </div>

          <div className="concluidos-select-wrapper">
            <label htmlFor="filtro-profissional">
              Profissional
            </label>

            <select
              id="filtro-profissional"
              value={funcionarioSelecionado}
              onChange={(e) =>
                setFuncionarioSelecionado(e.target.value)
              }
            >
              <option value="">Todos os profissionais</option>

              {funcionarios.map((funcionario) => (
                <option key={funcionario.id} value={funcionario.id}>
                  {funcionario.nome}
                </option>
              ))}
            </select>
          </div>
        </section>

        <section className="concluidos-table-card">
          <div className="concluidos-table-header">
            <div>
              <h3>Histórico de atendimentos</h3>
              <p>
                Valores, clientes e informações dos serviços concluídos.
              </p>
            </div>

            <span className="concluidos-record-count">
              {agendamentos.length}{" "}
              {agendamentos.length === 1 ? "registro" : "registros"}
            </span>
          </div>

          <div className="concluidos-table-scroll">
            <table className="concluidos-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Cliente</th>
                  <th>Telefone</th>
                  <th>Serviço</th>
                  <th>Preço original</th>
                  <th>Preço final</th>
                  <th>Ações</th>
                  <th>Profissional</th>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {agendamentos.map((agendamento) => (
                  <tr key={agendamento.id}>
                    <td>
                      <span className="concluidos-id">
                        #{agendamento.id}
                      </span>
                    </td>

                    <td className="concluidos-client">
                      {agendamento.cliente_nome || "Não informado"}
                    </td>

                    <td className="concluidos-muted">
                      {formatarTelefone(agendamento.telefone_celular)}
                    </td>

                    <td>
                      {agendamento.servico_nome || "Não informado"}
                    </td>

                    <td className="concluidos-price-original">
                      {formatarPreco(agendamento.servico_preco)}
                    </td>

                    <td className="concluidos-price-cell">
                      {editandoPreco === agendamento.id ? (
                        <input
                          className="concluidos-price-input"
                          type="number"
                          step="0.01"
                          min="0"
                          value={novoPreco}
                          onChange={(e) => setNovoPreco(e.target.value)}
                          aria-label={`Novo preço do agendamento ${agendamento.id}`}
                        />
                      ) : (
                        <span className="concluidos-price-final">
                          {formatarPreco(obterPrecoExibido(agendamento))}
                        </span>
                      )}
                    </td>

                    <td>
                      {editandoPreco === agendamento.id ? (
                        <div className="concluidos-action-group">
                          <button
                            className="concluidos-icon-button concluidos-save"
                            onClick={() => salvarPreco(agendamento.id)}
                            aria-label="Salvar preço"
                            title="Salvar preço"
                          >
                            ✓
                          </button>

                          <button
                            className="concluidos-icon-button concluidos-cancel"
                            onClick={cancelarEdicao}
                            aria-label="Cancelar edição"
                            title="Cancelar edição"
                          >
                            ✕
                          </button>
                        </div>
                      ) : (
                        <button
                          className="concluidos-edit-button"
                          onClick={() => iniciarEdicaoPreco(agendamento)}
                        >
                          Editar
                        </button>
                      )}
                    </td>

                    <td>
                      {agendamento.funcionario_nome || "Não informado"}
                    </td>

                    <td className="concluidos-muted">
                      {formatarData(agendamento.data)}
                    </td>

                    <td className="concluidos-muted">
                      {formatarHora(agendamento.hora)}
                    </td>

                    <td>
                      <span className="concluidos-status">
                        {agendamento.status}
                      </span>
                    </td>
                  </tr>
                ))}

                {agendamentos.length === 0 && (
                  <tr>
                    <td colSpan={11} className="concluidos-empty">
                      <span className="concluidos-empty-icon">✓</span>
                      <strong>Nenhum agendamento encontrado</strong>
                      <p>
                        Não há registros para o filtro selecionado.
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="concluidos-table-footer">
            <span>
              Exibindo {agendamentos.length}{" "}
              {agendamentos.length === 1 ? "registro" : "registros"}
            </span>
            <span>Histórico de serviços concluídos</span>
          </div>
        </section>

        <footer className="concluidos-footer">
          <button
            className="concluidos-button concluidos-button-secondary"
            onClick={() => navigate("/dashboard")}
          >
            <span aria-hidden="true">←</span>
            Voltar para o Dashboard
          </button>

          <button
            className="concluidos-button concluidos-button-primary"
            onClick={gerarRelatorio}
          >
            <span aria-hidden="true">↓</span>
            Gerar Relatório PDF
          </button>
        </footer>
      </section>
    </main>
  );
};

export default AgendamentosConcluidos;
